import type { InjectionKey } from 'vue'

export type AppStatus = 'up' | 'down'

export type AppStatusMap = Record<string, AppStatus>

export type AppsHealthContext = {
  statuses: AppStatusMap
}

const externalAppIds = [
  'maqrah',
  'halaqat',
  'dar-albayan',
  'sms',
  'screens',
  'itikaf',
  'survey',
  'ai',
  'proxy',
  'library',
  'privacy'
]

const internalAppStatuses: AppStatusMap = {
  'preschool-registration': 'up',
  'kindergarten-registration': 'up'
}

export const appsHealthContextKey: InjectionKey<AppsHealthContext> = Symbol('appsHealthContext')

export const getDefaultAppStatuses = (): AppStatusMap => ({
  ...Object.fromEntries(externalAppIds.map((id) => [id, 'down' as AppStatus])),
  ...internalAppStatuses
})
